import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const Tag = styled(Link)`
  display: inline-block;
  background-color: ${({ theme }) => theme.UI_COLORS.light};
  border-radius: 6px;
  padding: 0.8rem 1.1rem;
  color: ${({ theme }) => theme.UI_COLORS.secondary};
  font-size: ${({ theme }) => theme.FONT_SIZES.tag};
  font-weight: 400;
  text-transform: uppercase;
  border: 1px solid ${({ theme }) => theme.UI_COLORS.primary};
  text-decoration: none;
  cursor: default;
`;
